const IE = ({ value, warn, empty }) => {
  const ie = (value || "").replace(/[^\d]/g, "");

  if (ie.length === 0) return empty || "";

  if (ie.length !== 9) return warn ? "Inválido" : ie;

  return ie.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, "$1.$2.$3-$4");
};

export default IE;
